import { PropsWithChildren } from "react";
import { Topbar } from "./Topbar";
import { Helmet } from "react-helmet";

type Props = PropsWithChildren<{
  title?: string;
}>;

export const DefaultLayout = ({ children, title }: Props) => {
  return (
    <div className="w-full min-h-screen overflow-hidden bg-dark1">
      <Helmet>
        <title>Games {title ? `| ${title}` : ""}</title>
      </Helmet>
      <Topbar />
      {children}
    </div>
  );
};
